function staticHeaderOnScroll() {
  const header = document.getElementById("HeaderWrapper");
  const mobileNav = document.getElementById("MobileNav");
  if (window.scrollY >= 100) {
    header.style.position = "fixed";
    header.style.width = "100%";
    header.style.top = "0";
    header.classList.add("header-wrapper--compressed");
    // Adiciona classe no menu mobile para alinhar ao topo
    if (mobileNav) mobileNav.classList.add("menu-align-top");
  } else {
    header.style.position = "inherit";
    header.style.width = "100%";
    header.classList.remove("header-wrapper--compressed");
    // Remove classe do menu mobile
    if (mobileNav) mobileNav.classList.remove("menu-align-top");
  }
}

// Correção COMPLEMENTAR para iOS - trabalha junto com o sistema original
function addIOSTouchSupport() {
  // Só aplica em dispositivos móveis iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (!isIOS || window.innerWidth > 768) {
    return;
  }

  const mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
  const mobileNavContainer = document.getElementById('MobileNav');

  if (!mobileNavTrigger || !mobileNavContainer) {
    setTimeout(addIOSTouchSupport, 500);
    return;
  }

  // Adiciona apenas suporte a touch para iOS, SEM interferir na funcionalidade existente
  let lastTouchTime = 0;
  let isProcessing = false;

  // Função para clonar o footer do menu
  function ensureFooterCloned() {
    const headerFooter = document.querySelector('#MobileNavFooter');
    const footerMenus = document.querySelector('#FooterMenus');

    if (!headerFooter || !footerMenus) {
      return;
    }

    // Se o footer já existe no menu e tem conteúdo, não precisa clonar
    if (headerFooter.children.length > 0) {
      return;
    }

    const clone = footerMenus.cloneNode(true);
    clone.id = '';

    // Limpa o footer atual e adiciona o clone
    headerFooter.innerHTML = '';
    headerFooter.appendChild(clone);

    // Atualiza IDs dos elementos de localização se existirem
    const localizationForm = headerFooter.querySelector('.multi-selectors');
    if (localizationForm) {
      localizationForm.querySelectorAll('[data-disclosure-toggle]').forEach(el => {
        const controls = el.getAttribute('aria-controls');
        const describedby = el.getAttribute('aria-describedby');

        if (controls) {
          el.setAttribute('aria-controls', controls + '-header');
          const list = document.getElementById(controls);
          if (list) list.id = controls + '-header';
        }

        if (describedby) {
          el.setAttribute('aria-describedby', describedby + '-header');
          const label = document.getElementById(describedby);
          if (label) label.id = describedby + '-header';
        }
      });
    }

  }

  mobileNavTrigger.addEventListener('touchstart', function (e) {
    // Garante que o evento é apenas para o botão, não para links internos
    if (e.target !== mobileNavTrigger && !mobileNavTrigger.contains(e.target)) {
      return;
    }

    const currentTime = Date.now();

    // Debounce para evitar múltiplos toques
    if (currentTime - lastTouchTime < 300 || isProcessing) {
      return;
    }

    isProcessing = true;
    lastTouchTime = currentTime;

    e.preventDefault();
    e.stopPropagation();

    // Toggle do menu usando o sistema original
    setTimeout(() => {
      const isCurrentlyOpen = mobileNavContainer.classList.contains('is-active');

      if (isCurrentlyOpen) {
        mobileNavContainer.classList.remove('is-active');
        document.documentElement.classList.remove('mobile-nav-open');
        mobileNavTrigger.classList.remove('is-active');
      } else {
        mobileNavContainer.classList.add('is-active');
        document.documentElement.classList.add('mobile-nav-open');
        mobileNavTrigger.classList.add('is-active');

        // Garante que o footer seja clonado quando abrir o menu
        setTimeout(ensureFooterCloned, 100);
      }

      setTimeout(() => {
        isProcessing = false;
      }, 100);

    }, 50);

  }, { passive: false });

  // Previne cliques duplos em iOS apenas no trigger, não nos links internos
  mobileNavTrigger.addEventListener('click', function (e) {
    if (isIOS) {
      if (e.target !== mobileNavTrigger && !mobileNavTrigger.contains(e.target)) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
    }
  }, { passive: false });

  // Fecha o menu mobile apenas ao clicar em links finais de nível 1
  mobileNavContainer.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (link && mobileNavContainer.contains(link)) {
      // Verifica se o link tem submenu (elemento irmão com classe .submenu)
      const hasSubmenu = link.nextElementSibling && link.nextElementSibling.classList.contains('submenu');
      // Verifica se o link está dentro de um submenu (nível 2 ou mais)
      const insideSubmenu = !!link.closest('.submenu');
      if (hasSubmenu) {
        // Expande/colapsa o submenu
        link.nextElementSibling.classList.toggle('open');
        e.preventDefault(); // Não navega
        // Não fecha o menu mobile
        return;
      }
      // Só fecha o menu se NÃO estiver dentro de um submenu (ou seja, for nível 1)
      if (!insideSubmenu) {
        mobileNavContainer.classList.remove('is-active');
        document.documentElement.classList.remove('mobile-nav-open');
        if (mobileNavTrigger) mobileNavTrigger.classList.remove('is-active');
      }
      // Se estiver dentro de submenu, permite navegação mas mantém o menu aberto
    }
  });

  // Aplica estilos mínimos apenas para touch
  mobileNavTrigger.style.cssText += `
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    touch-action: manipulation !important;
    -webkit-tap-highlight-color: transparent !important;
    pointer-events: auto !important;
  `;
}

window.addEventListener("scroll", staticHeaderOnScroll);

// Aplica a correção iOS após o carregamento, sem interferir no sistema original
setTimeout(addIOSTouchSupport, 1000);
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(addIOSTouchSupport, 500);
});
window.addEventListener('load', () => {
  setTimeout(addIOSTouchSupport, 500);
});

// Adiciona classe is-ios ao <html> apenas em iOS
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  document.documentElement.classList.add('is-ios');
}
